// Static PEEPING brand artwork only. No stock photos of people are used anywhere in the app.
export const BRAND_IMAGE = "/peeping-brand.jpg";
export const BG_IMAGE = "/peeping-bg.jpg";
